<template>
  <div class="admin">
    <div class="fluid-container">
      <div class="row no-gutters">
        <!-- menu admin -->
        <div class="col-3">
          <menu-admin></menu-admin>
        </div>
        <!-- menu admin -->

        <!-- main -->
        <div class="col-9 main pb-5">
          <div class="row">
            <div class="col-12 mb-2">
              <div class="title-admin">
                <h1 class="display-2 font-weight-black">{{ nombre }}</h1>
                <div class="acciones">
                  <v-btn large color="primary" to="/admin/agregar-categoria">
                    <v-icon class="mr-3">add</v-icon>Agregar categoría
                  </v-btn>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-4">
            <div class="col-12">
              <v-text-field
                label="Nombre de la categoría"
                placeholder="nombre"
                outlined
                v-model="nombre"
              />

              <div class="d-flex">
                <v-btn large color="primary" @click="validar()">
                  Guardar categoría
                </v-btn>

                <v-btn large color="red" class="ml-3" dark @click="showAlert()">
                  Eliminar categoría
                </v-btn>
              </div>
            </div>
          </div>
        </div>
        <!-- /main -->
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import { setTimeout } from "timers";
import myUpload from "vue-image-crop-upload";
const axios = require("axios");
export default {
  data() {
    return {
      nombre: "",
      error: "",
      loader: false,
      id_categoria: this.$route.params.id,
    };
  },

  methods: {
    validar() {
      if (this.nombre == "") {
        this.$swal({
          type: "error",
          customClass: "arriba",
          title: "Ingresa el nombre de la categoría",
          showConfirmButton: true,
        });
      } else {
        //Los datos requeridos se ingresaron
        this.actualizar();
      }
    },
    actualizar() {
      this.loader = true;
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=updateCategoria" +
            "&id=" +
            this.id_categoria +
            "&nombre=" +
            this.nombre
        )
        .then((response) => {
          this.loader = false;
          this.error = "";
          this.$swal({
            type: "success",
            title: "La categoría se actualizó exitosamente",
            showConfirmButton: false,
            timer: 1500,
          });
        })
        .catch((error) => console.log(error));
    },
    getCategoriaData() {
      //Obtenemos los datos del producto
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getCategoriaData&id=" +
            this.id_categoria
        )
        .then((response) => {
          this.nombre = response.data.nombre;
        })
        .catch((error) => console.log(error));
    },
    deleteCategoria() {
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=deleteCategoria&id=" +
            this.id_categoria
        )
        .then((response) => {
          this.$swal({
            type: "success",
            title: "La categoría se borró exitosamente",
            showConfirmButton: false,
            timer: 1500,
          });

          setTimeout(
            () =>
              router.push({
                name: "categorias_admin",
              }),
            1500
          );
        })
        .catch((error) => console.log(error));
    },
    showAlert() {
      // Use sweetalert2
      this.$swal({
        title: "Estás seguro que deseas eliminar la categoría",
        text: "No podrás deshacer este cambio!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si, estoy seguro!",
        cancelButtonText: "No!",
      }).then((result) => {
        if (result.value) {
          //Enviamos petición al servidor
          this.deleteCategoria();
        }
      });
    },
  },
  computed: {},
  mounted() {
    this.getCategoriaData();
  },
};
</script>
